import React from "react";
import { Box, Button, Typography } from "@mui/material";
import OnboardingSkipButton from "../OnboardingSkipButton";
import AnalyticsSettingsMenu from "../../../components/AnalyticsSettingsMenu";

/**
 * Chat onboarding header row: Back, Skip and the progress label.
 *
 * Back is offered only once there is an answer to return to. Before that a
 * spacer holds the row layout so Skip and the progress label do not shift when
 * the control appears.
 */
export default function ChatHeader({
  canGoBack,
  backDisabled = false,
  skipDisabled = false,
  onBack,
  onSkip,
  progressLabel,
}) {
  return (
    <Box
      sx={{
        position: "relative",
        zIndex: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: { xs: 2.5, md: 4 },
        pt: { xs: 1.5, md: 2 },
        pb: 0.5,
        flexShrink: 0,
      }}
    >
      {canGoBack ? (
        <Button
          type="button"
          variant="text"
          onClick={onBack}
          disabled={backDisabled}
          data-testid="onboarding-chat-back"
          sx={{
            minHeight: 32,
            px: 1,
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 600,
            fontSize: 13,
            color: "#4A2CF5",
            "&:hover": { backgroundColor: "rgba(74, 44, 245, 0.08)" },
          }}
        >
          Back
        </Button>
      ) : (
        <Box aria-hidden="true" sx={{ minHeight: 32, minWidth: 56 }} />
      )}
      <Box sx={{display: "flex", alignItems: "center", gap: 1}}>
        <OnboardingSkipButton onClick={onSkip} disabled={skipDisabled} compact />
        <AnalyticsSettingsMenu />
      </Box>
      <Typography
        data-testid="onboarding-chat-progress"
        sx={{
          fontSize: 12,
          fontWeight: 600,
          color: "#9AA0AE",
          letterSpacing: "0.04em",
          textTransform: "uppercase",
        }}
      >
        {progressLabel}
      </Typography>
    </Box>
  );
}
